import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-nav-link',
  templateUrl: './nav-link.component.html',
})
export class NavLinkComponent {
  @Input() target: string | undefined;
  @Input() class: string | undefined;
}
